import { render, staticRenderFns } from "./PhoneFooter.vue?vue&type=template&id=10984422&scoped=true&"
import script from "./PhoneFooter.vue?vue&type=script&lang=js&"
export * from "./PhoneFooter.vue?vue&type=script&lang=js&"
import style0 from "./PhoneFooter.vue?vue&type=style&index=0&id=10984422&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10984422",
  null
  
)

export default component.exports